import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd287bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "core" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "三大看板，优化点一目了然", -1 /* HOISTED */))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "一键体检，优化策略信手拈来", -1 /* HOISTED */))
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src", "controls"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 产品功能 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _hoisted_3,
          (_ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.MD))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("；")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock("br", _hoisted_4)),
          _hoisted_5
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_tabs, {
        activeKey: $data.tab.active,
        "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => (($data.tab.active) = $event)),
        centered: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tab.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: index+1,
              tab: item.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_row, {
                  class: _normalizeClass({tab_show:$data.tab.show===index+1})
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, {
                      xs: 24,
                      lg: {offset:1,span:10}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["media", `m_${index+1}`])
                        }, [
                          (item.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                alt: "",
                                src: item.image
                              }, null, 8 /* PROPS */, _hoisted_6))
                            : _createCommentVNode("v-if", true),
                          (item.video)
                            ? (_openBlock(), _createElementBlock("video", {
                                key: 1,
                                src: item.video,
                                controls: _ctx.$FN.Agent.client()==='Mobile',
                                preload: "",
                                autoplay: "",
                                loop: "",
                                muted: ""
                              }, null, 8 /* PROPS */, _hoisted_7))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_a_col, {
                      xs: 24,
                      lg: {offset:2,span:10}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["item", `i_${index+1}`])
                        }, [
                          (item.sub)
                            ? (_openBlock(), _createBlock(_component_a_typography_title, {
                                key: 0,
                                level: 5
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.sub), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.text, (v) => {
                            return (_openBlock(), _createBlock(_component_a_typography_paragraph, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(v), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          }), 256 /* UNKEYED_FRAGMENT */)),
                          _createVNode(_component_a_space, {
                            size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "link",
                                class: "button_1",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$RQ.GoGSS()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 免费体验 ")
                                ]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_a_button, {
                                type: "link",
                                class: "button_1",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','demo')))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 预约咨询 ")
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["size"])
                        ], 2 /* CLASS */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class"])
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["tab"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["activeKey"])
    ])
  ]))
}